import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export interface PageBuilderNumericTextboxModelConfig extends DynamicInputModelConfig {
}

export class PageBuilderNumericTextboxModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_numeric_textbox'; 

	constructor(config: PageBuilderNumericTextboxModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
	}

	static initModel(_component: PageBuilderItem): PageBuilderNumericTextboxModel { 
		const formModel = new PageBuilderNumericTextboxModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX,
            NAME: 'Numeric Textbox',
            ICON: 'text_fields',
            PROPERTIES: [
                { ID: 'CODE', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', VALUE: 'Ligne' },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
            ]
        };
    }
}